export default "__VITE_ASSET__CpWeHQyX__"